// extracted by mini-css-extract-plugin
module.exports = {"btn":"button_btn__i3_cy","primary":"button_primary__rds5q","secondary":"button_secondary__m5f7i"};